import {
  Abc,
  CategoryOutlined,
  CheckCircle,
  ErrorOutlineOutlined,
  RateReviewOutlined,
  WarningAmberOutlined,
} from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Divider,
  FormControl,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import SlowMotionVideoOutlinedIcon from "@mui/icons-material/SlowMotionVideoOutlined";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMutation } from "@apollo/client";

import AccordianUtils from "../../../../../utils/accordian";
import OrderComponent from "./Order.component";
import TextArtifacts from "./TextArtifact.component";
import DealerEngagement from "./DealerEngagement";
import ReviewComponent from "./ReviewComponent";
import VideoArtifact from "./VideoArtifact.component";
import SurveyArtifact from "./SurveyArtifact.component";
import ServiceMaintenance from "./ServiceMaintenance.component";

import { SalesAidsStyles } from "./SalesAidsStyles";
import AppButton from "../../../../base/AppButton.component";
import Theme from "../../../../../utils/Theme";
import { DialogStyle } from "../dialog/dialogBody/Dialog.styles";
import { generateRandomId, options } from "../../../../../utils/Utils";
import { useAuth } from "../../../../../context/Auth.context";
import WalkthroughVideo from "./WalkthroughVideo";
import Appointment from "./Appointment";

import {
  MANAGE_ARTIFACTS,
  UPDATE_SALES_AIDS,
  VIDEO_GENERATE,
} from "../../../../../graphql/mutation/mutation";
import AdminServices from "./AdminServices";
import {
  QUOTE_DATA,
  ServiceData,
  TRADE_DATA,
} from "../../../omniService/ServiceData";
import TradeVehicleArtifacts from "./TradeVehicleArtifacts";
import RequestQuoteArtifact from "./RequestQuoteArtifact";
import VehicleTransactionType from "./VehicleTransactionType.component";
import WarrantyArtifacts from "./WarrantyArtifact.component";

const referralFollowup = Array.from({ length: 30 }, (_, index) =>
  (index + 1).toString(),
);

const csiFollowup = Array.from({ length: 30 }, (_, index) =>
  (index + 1).toString(),
);

const serviceMaintenanceFollowup = Array.from({ length: 75 }, (_, index) =>
  (index + 1).toString(),
);

// ── Shared defaults (mirrors ServiceMaintenance.component DEFAULTS) ──
const SERVICE_MAINTENANCE_DEFAULTS = {
  followup_message_1:
    "Many of our customers like to maintain all their vehicles in one place, so we wanted to offer the same convenience for your other vehicle(s) if that would be helpful.",
  es_followup_message_1:
    "Muchos de nuestros clientes prefieren mantener todos sus vehículos en un solo lugar, así que queríamos ofrecer la misma comodidad para su(s) otro(s) vehículo(s) si eso sería útil.",
  followup_message_2:
    "We want to make sure you're completely satisfied with your purchase",
  es_followup_message_2:
    "Queremos asegurarnos de que estés completamente satisfecha con tu compra",
  followup_message_3:
    "Thank you for choosing our dealership. We hope you're happy with your purchase",
  es_followup_message_3:
    "Gracias por elegir nuestro concesionario. Esperamos que estés contenta con tu compra",
};

const ArtifactsParent = (props) => {
  const { data, edit = false, refetch, selectedAvatar, setTab } = props;
  const { dealershipId } = useParams();
  const auth = useAuth();

  const [order, setOrder] = useState([]);

  const [expandedIndex, setExpandedIndex] = useState(0);
  const [checked, setChecked] = useState(false);
  const [success, setSuccess] = useState(false);
  const [isAISuccess, setAISuccess] = useState(false);
  const [isError, setError] = useState(false);
  const [isSave, setSave] = useState(false);
  const [bubbleStates, setBubbleStates] = useState({});
  const [aiTiming, setTiming] = useState({
    arr_length: 0,
    time: 0,
  });

  const [artifacts, setArtifacts] = useState({
    dealership_id: "",
    follow_up_days: 7,
    csi_followup_days: 10,
    service_maintenance_followup_1: 7,
    service_maintenance_followup_2: 30,
    service_maintenance_followup_3: 75,
    verification_followup: false,
    csi_followup: false,
    service_maintenance_followup: false,
    text: [
      {
        artifactId: generateRandomId(6),
        text: "",
        es_text: "",
        position: null,
        isEdit: false,
      },
    ],
    survey: [
      {
        artifactId: generateRandomId(6),
        position: null,
        question: "",
        es_question: "",
        options: ["", "", "", ""],
        es_options: ["", "", "", ""],
        isEdit: false,
      },
    ],
    vehicle_transaction_type: [
      {
        artifactId: generateRandomId(6),
        position: null,
        vehicle_information:
          "In order to customize your experience, we are going to ask you a few questions. This will help make sure only content that is pertinent to you will be shown",
        es_vehicle_information:
          "Para personalizar su experiencia, le haremos algunas preguntas. Esto ayudará a garantizar que solo se muestre contenido que sea pertinente para usted",
        vehicle_message: "Is your vehicle New, Used, CPO, Other",
        es_vehicle_message: "¿Su vehículo es Nuevo, Usado, CPO, Otro?",
        vehicle_options: {
          option1: "New",
          option2: "Used",
          option3: "CPO",
          option4: "Other",
        },
        es_vehicle_options: {
          option1: "Nuevo",
          option2: "Usado",
          option3: "CPO",
          option4: "Otro",
        },
        transaction_message: "How are you buying new car?",
        es_transaction_message: "¿Cómo está comprando su coche nuevo?",
        transaction_options: {
          option1: "Finance",
          option2: "Lease",
          option3: "Cash",
          option4: "Balloon",
        },
        es_transaction_options: {
          option1: "Financiamiento",
          option2: "Arrendamiento",
          option3: "Efectivo",
          option4: "Globo",
        },
        isEdit: false,
      },
    ],
    video: [
      {
        artifactId: generateRandomId(6),
        url: "",
        es_url: "",
        title: "",
        es_title: "",
        position: null,
        isEdit: false,
      },
    ],
    review: {
      artifactId: generateRandomId(6),
      message: "Can you leave a 5-Star review for us? It would mean a lot!",
      es_message:
        "¿Nos podrías dejar una reseña de 5 estrellas? ¡Sería muy valioso!",
      facebook: "",
      google: "",
      dealer_rater: "",
      review_question:
        "We appreciate you choosing us! Our team strives for a 5-star experience. Would you say we earned that rating?",
      es_review_question:
        "¡Le agradecemos que nos haya elegido! Nuestro equipo se esfuerza por brindarle una experiencia de 5 estrellas. ¿Diría usted que nos hemos ganado esa calificación?",
      second_review_question:
        "We appreciate you choosing us! Our team strives for a 5-star experience. Would you say we earned that rating?",
      es_second_review_question:
        "¡Le agradecemos que nos haya elegido! Nuestro equipo se esfuerza por brindarle una experiencia de 5 estrellas. ¿Diría usted que nos hemos ganado esa calificación?",
      referral_question:
        "Would you be willing to give me a referral for someone who is in the market?",
      es_referral_question:
        "¿Estaría dispuesto a darme una referencia de alguien que esté en el mercado?",
      position: null,
      isEdit: false,
    },
    service_maintenance: {
      artifactId: generateRandomId(6),
      ...SERVICE_MAINTENANCE_DEFAULTS,
      position: null,
      isEdit: false,
    },
    dealer_app: {
      artifactId: generateRandomId(6),
      message: "",
      es_message: "",
      playstore: "",
      appstore: "",
      position: null,
      isEdit: false,
    },
    walkthrough_video: {
      artifactId: generateRandomId(6),
      video_url: "",
      es_video_url: "",
      text: "",
      es_text: "",
      knowledgehub_video_url: "",
      es_knowledgehub_video_url: "",
      knowledgehub_text: "",
      es_knowledgehub_text: "",
      isEdit: false,
    },
    appointment: {
      artifactId: generateRandomId(6),
      message:
        "Let's set your first service appointment while we have a moment",
      es_message:
        "Vamos a programar tu primera cita de servicio mientras tenemos un momento",
      preference_options: ["Waiting for car", "Drop off", "Pick up later"],
      es_preference_options: [
        "Esperando el coche",
        "Dejarlo",
        "Recoger más tarde",
      ],
      position: null,
      isEdit: false,
    },
    services: [
      {
        artifactId: generateRandomId(6),
        service_id: "",
        service_text: "",
        es_service_text: "",
        isEdit: false,
      },
    ],
    trade_artifact: {
      artifactId: generateRandomId(6),
      text: "We see that you have the following vehicles on your insurance policy. Which if any are you trading in today?",
      es_text:
        "Vemos que tiene los siguientes vehículos en su póliza de seguro. ¿Cuál, si es que hay alguno, está entregando hoy?",
      isEdit: false,
    },
    warranty: {
      artifactId: generateRandomId(6),
      // warranty_message: "",
      // warranty_es_message: "",
      is_enabled: false,
      isEdit: false,
    },
    request_quote_artifact: {
      artifactId: generateRandomId(6),
      text: "After reviewing your current insurance setup, it looks like you might be overpaying for your insurance. Would you like us to check exactly how much we can save you? ",
      es_text:
        "Después de revisar su configuración de seguro actual, parece que podría estar pagando de más por su seguro. ¿Le gustaría que verifiquemos exactamente cuánto podemos ahorrarle? ",
      quote_options: ["Yes, I'd like a Quote", "No Quote at this Time"],
      es_quote_options: [
        "Sí, me gustaría un presupuesto",
        "No hay cotización disponible en este momento.",
      ],
      isEdit: false,
      quote_question:
        "In a moment, we will ask for several pieces of information that will be really helpful to give you an awesome quote as quick as possible so you can save the maximum amount of money in the minimum amount of time. They're all optional, so feel free to skip one if you don't want to provide the information. Thanks and we're really looking forward to seeing how much you might be able to save.",
      es_quote_question:
        "En un momento, le pediremos varias piezas de información que serán realmente útiles para brindarle una excelente cotización lo más rápido posible, para que pueda ahorrar la máxima cantidad de dinero en el menor tiempo posible. Todos son opcionales, así que siéntase libre de omitir uno si no desea proporcionar la información. Gracias y esperamos ver cuánto podría ahorrar.",
    },
  });

  const updateArtifacts = async (data) => {
    const artifactTypes = [
      { key: "text", field: "text", condition: data?.text, isArray: true },
      {
        key: "survey",
        field: "survey",
        condition: data?.question,
        isArray: true,
      },
      {
        key: "vehicle_transaction_type",
        field: "vehicle_transaction_type",
        condition:
          data?.vehicle_information ||
          data?.vehicle_message ||
          data?.transaction_message ||
          data?.es_vehicle_information ||
          data?.es_vehicle_message ||
          data?.es_transaction_message,
        isArray: true,
      },
      { key: "video", field: "video", condition: data?.url, isArray: true },
      {
        key: "review",
        field: "review",
        condition: data?.review_question || data?.second_review_question,
        isArray: false,
      },
      {
        key: "dealer_app",
        field: "dealer_app",
        condition: data?.appstore || data?.playstore,
        isArray: false,
      },
      {
        key: "appointment",
        field: "appointment",
        condition: data?.preference_options?.length > 0,
        isArray: false,
      },
    ];
    setArtifacts((prev) => {
      const updatedArtifacts = { ...prev };

      artifactTypes.forEach(({ field, condition, isArray }) => {
        if (condition) {
          updatedArtifacts[field] = isArray
            ? prev[field]?.map((artifact) =>
                artifact.artifactId === data.artifactId
                  ? { ...artifact, position: data.position }
                  : { ...artifact, position: null },
              )
            : data.artifactId === prev[field]?.artifactId
              ? { ...data, position: data.position }
              : { ...prev[field], position: null };
        }
      });

      return updatedArtifacts;
    });
  };

  const handleArrowClick = (item, value) => {
    setOrder((prevOrder) => {
      return prevOrder.some((data) => data.artifactId === item.artifactId)
        ? prevOrder.map((data) =>
            data.artifactId === item.artifactId ? item : data,
          )
        : [...prevOrder, item];
    });
    setArtifacts((prev) => {
      const updatedValue = [
        "text",
        "survey",
        "vehicle_transaction_type",
        "video",
      ].includes(value)
        ? {
            [value]: prev[value].map((data) =>
              data?.artifactId === item?.artifactId
                ? { ...data, isEdit: false }
                : data,
            ),
          }
        : { [value]: { ...item, isEdit: false } };

      return { ...prev, ...updatedValue };
    });
  };

  const handleRemove = (item, field) => {
    setArtifacts((prev) => ({
      ...prev,
      [field]: prev[field]?.filter(
        (artifact) => artifact.artifactId !== item.artifactId,
      ),
    }));

    const newOrder = order.filter(
      (artifact) => artifact.artifactId !== item.artifactId,
    );
    setOrder(newOrder);
  };

  const switchHandle = () => {
    updateSalesAids({
      variables: {
        salesAidsInput: {
          dealership_id: parseInt(dealershipId),
          sales_aids: !checked,
        },
      },
    });
    setChecked(!checked);
  };

  const fetchArtifacts = (data) => {
    const parseOptions = (options) => (options ? JSON.parse(options) : []);

    // ── FIX: safely parse JSON string OR return object as-is ──
    const parseOpts = (val) => {
      if (!val) return { option1: "", option2: "", option3: "", option4: "" };
      if (typeof val === "string") {
        try {
          return JSON.parse(val);
        } catch {
          return { option1: "", option2: "", option3: "", option4: "" };
        }
      }
      return val; // already an object
    };

    const generateArtifact = (item) => ({
      ...item,
      artifactId: generateRandomId(6),
    });

    const updateSurvey = {
      text: data?.textArtifact?.length
        ? data.textArtifact.map((text) => generateArtifact(text))
        : artifacts?.text,
      survey: data?.surveyArtifact?.length
        ? data.surveyArtifact.map((survey) => ({
            ...generateArtifact(survey),
            options: parseOptions(survey.options),
            es_options: parseOptions(survey.es_options),
          }))
        : artifacts?.survey,

      // ── FIX: parse VTT options properly (they come as JSON strings from DB) ──
      vehicle_transaction_type: data?.vehicleTransactionArtifact?.length
        ? data.vehicleTransactionArtifact.map((vtt) => ({
            ...generateArtifact(vtt),
            vehicle_options: parseOpts(vtt.vehicle_options),
            es_vehicle_options: parseOpts(vtt.es_vehicle_options),
            transaction_options: parseOpts(vtt.transaction_options),
            es_transaction_options: parseOpts(vtt.es_transaction_options),
          }))
        : artifacts?.vehicle_transaction_type,

      video: data?.videoArtifact?.length
        ? data.videoArtifact.map((video) => generateArtifact(video))
        : artifacts?.video,
      review: generateArtifact(data?.reviewUrl),
      dealer_app: generateArtifact(data.dealerAppUrl),
      appointment:
        data?.appointment?.preference_options?.length > 0
          ? {
              ...generateArtifact(data?.appointment),
              preference_options: parseOptions(
                data?.appointment.preference_options,
              ),
              es_preference_options: parseOptions(
                data?.appointment.es_preference_options,
              ),
            }
          : generateArtifact(data?.appointment),

      service_maintenance: data?.ServiceMaintenanceArtifact
        ? {
            ...generateArtifact(data.ServiceMaintenanceArtifact),
            followup_message_1:
              data.ServiceMaintenanceArtifact.followup_message_1 ||
              SERVICE_MAINTENANCE_DEFAULTS.followup_message_1,
            es_followup_message_1:
              data.ServiceMaintenanceArtifact.es_followup_message_1 ||
              SERVICE_MAINTENANCE_DEFAULTS.es_followup_message_1,
            followup_message_2:
              data.ServiceMaintenanceArtifact.followup_message_2 ||
              SERVICE_MAINTENANCE_DEFAULTS.followup_message_2,
            es_followup_message_2:
              data.ServiceMaintenanceArtifact.es_followup_message_2 ||
              SERVICE_MAINTENANCE_DEFAULTS.es_followup_message_2,
            followup_message_3:
              data.ServiceMaintenanceArtifact.followup_message_3 ||
              SERVICE_MAINTENANCE_DEFAULTS.followup_message_3,
            es_followup_message_3:
              data.ServiceMaintenanceArtifact.es_followup_message_3 ||
              SERVICE_MAINTENANCE_DEFAULTS.es_followup_message_3,
          }
        : artifacts?.service_maintenance,

      walkthrough_video: generateArtifact(data.walkthroughVideo),
      services:
        data?.serviceId?.length > 0
          ? data.serviceId.map((service) => ({
              ...generateArtifact(service),
              id: service?.id,
              service_id: service?.service_id || "",
              service_text: service?.service_text || "",
            }))
          : artifacts?.services,
      trade_artifact: generateArtifact(data?.tradeArtifact),
      warranty: data?.warrantyArtifact
        ? {
            ...generateArtifact(data.warrantyArtifact),
            is_enabled: !!data.warrantyArtifact?.is_enabled,
          }
        : artifacts?.warranty,
      request_quote_artifact: {
        ...generateArtifact(data?.quoteArtifact),
        quote_options: parseOptions(data?.quoteArtifact?.quote_options),
        es_quote_options: parseOptions(data?.quoteArtifact?.es_quote_options),
      },
      dealership_id: data?.dealership_id || artifacts?.dealership_id,
      follow_up_days: data?.follow_up_days,
      csi_followup_days: data?.csi_followup_days || 10,
      service_maintenance_followup_1: data?.service_maintenance_followup_1 || 7,
      service_maintenance_followup_2:
        data?.service_maintenance_followup_2 || 30,
      service_maintenance_followup_3:
        data?.service_maintenance_followup_3 || 75,
      verification_followup: data?.verification_followup,
      csi_followup: data?.csi_followup,
      service_maintenance_followup: data?.service_maintenance_followup,
    };

    setArtifacts(updateSurvey);

    const sortedArtifacts = [
      ...updateSurvey.text,
      ...updateSurvey.survey,
      ...updateSurvey.vehicle_transaction_type,
      ...updateSurvey.video,
      updateSurvey.review,
      updateSurvey.dealer_app,
      updateSurvey.appointment,
      updateSurvey.warranty,
    ]
      .filter((item) => item != null && item?.position != null)
      .sort((a, b) => {
        if (a?.position && b?.position) return a.position - b.position;
        if (a?.position) return -1;
        if (b?.position) return 1;
        return 0;
      });

    setOrder(sortedArtifacts);

    // ── FIX: key bubbleStates by the item's new artifactId (random string),
    //         not by the DB artifact_id integer.
    //         Match each displayRule's artifact_id (DB int) to the loaded
    //         item's DB id, then use that item's new artifactId as the key. ──
    if (data?.displayRules?.length) {
      const allLoadedItems = [
        ...updateSurvey.text,
        ...updateSurvey.survey,
        ...updateSurvey.vehicle_transaction_type,
        ...updateSurvey.video,
        updateSurvey.review,
        updateSurvey.dealer_app,
        updateSurvey.appointment,
        updateSurvey.warranty,
      ].filter(Boolean);

      const newBubbleStates = {};
      data.displayRules.forEach((rule) => {
        let vehicleRules = {};
        let transactionRules = {};
        try {
          vehicleRules = JSON.parse(rule.vehicle_rules || "{}");
        } catch {
          vehicleRules = {};
        }
        try {
          transactionRules = JSON.parse(rule.transaction_rules || "{}");
        } catch {
          transactionRules = {};
        }
        const merged = { ...vehicleRules, ...transactionRules };

        // Find the loaded item whose DB id matches this rule's artifact_id
        const matchedItem = allLoadedItems.find(
          (item) => item.id === rule.artifact_id,
        );

        if (matchedItem?.artifactId) {
          // Key by the new random artifactId — this is what OrderComponent uses
          newBubbleStates[matchedItem.artifactId] = merged;
        } else {
          // Fallback: key by DB artifact_id (for items not in the order list)
          newBubbleStates[rule.artifact_id] = merged;
        }
      });

      setBubbleStates((prev) => ({ ...prev, ...newBubbleStates }));
    }
  };

  useEffect(() => {
    if (data) {
      fetchArtifacts(data);
      setChecked(data.sales_aids);
    }
  }, [data]);

  const [videoGenerate, { loading: videoLoading }] = useMutation(
    VIDEO_GENERATE,
    {
      onCompleted: async (data) => {
        if (data?.videoGenerate?.video_url === "Success") {
          setAISuccess(true);
          setTimeout(() => {
            setAISuccess(false);
            if (edit) refetch();
          }, 5000);
        }
      },
    },
  );

  const [manageArtifacts, { loading }] = useMutation(MANAGE_ARTIFACTS, {
    onCompleted: async (data) => {
      if (data?.manageArtifacts) {
        const textArtifact = data?.manageArtifacts?.text;
        const surveyArtifact = data?.manageArtifacts?.survey;
        const vehicleTransactionType =
          data?.manageArtifacts?.vehicleTransactionArtifact;
        const servicesArtifact = data?.manageArtifacts?.service;
        const dealerAppArtifact = data?.manageArtifacts?.dealer_app;
        const appointmentArtifact = data?.manageArtifacts?.appointment;
        const tradeArtifact = data?.manageArtifacts?.tradeArtifact;
        const warrantyArtifact = data?.manageArtifacts?.warrantyArtifact;
        const reviewArtifact = data?.manageArtifacts?.review;
        const quoteArtifact = data?.manageArtifacts?.quoteArtifact;
        const serviceArtifact =
          data?.manageArtifacts?.ServiceMaintenanceArtifact;
        const surveyOther = data?.manageArtifacts?.surveyOther;

        const englishText = surveyOther?.find(
          (item) => item?.language_id === 1,
        );
        const spanishText = surveyOther?.find(
          (item) => item?.language_id === 2,
        );

        const arr = [
          ...(textArtifact || []).map(
            (input) =>
              input?.position &&
              (input?.text || input?.es_text) && {
                text: input.text,
                es_text: input?.es_text,
                language_id: [1, 2],
                artifact_type_id: 1,
                artifact_id: input.id,
              },
          ),
          ...(surveyArtifact || []).map(
            (input) =>
              input?.position &&
              (input?.question || input?.es_question) && {
                text: input.question,
                es_text: input?.es_question,
                language_id: [1, 2],
                artifact_type_id: 2,
                artifact_id: input.id,
              },
          ),
          ...(vehicleTransactionType || []).map(
            (input) =>
              input?.position &&
              (input?.vehicle_information || input?.es_vehicle_information) && {
                text: input.vehicle_information,
                es_text: input?.es_vehicle_information,
                language_id: [1, 2],
                artifact_type_id: 17,
                artifact_id: input.id,
              },
          ),
          ...(servicesArtifact || []).map(
            (input) =>
              (input?.service_text || input?.es_service_text) && {
                text: input.service_text,
                es_text: input?.es_service_text,
                language_id: [1, 2],
                artifact_type_id: 4,
                artifact_id: input.id,
              },
          ),
          dealerAppArtifact &&
            (dealerAppArtifact?.message || dealerAppArtifact?.es_message) &&
            dealerAppArtifact?.position && {
              text: dealerAppArtifact?.message,
              es_text: dealerAppArtifact?.es_message,
              language_id: [1, 2],
              artifact_type_id: 5,
              artifact_id: dealerAppArtifact?.id,
            },
          appointmentArtifact &&
            (appointmentArtifact?.message || appointmentArtifact?.es_message) &&
            appointmentArtifact?.position && {
              text: appointmentArtifact?.message,
              es_text: appointmentArtifact?.es_message,
              language_id: [1, 2],
              artifact_type_id: 6,
              artifact_id: appointmentArtifact?.id,
            },
          reviewArtifact &&
            (reviewArtifact?.review_question ||
              reviewArtifact?.es_review_question) &&
            reviewArtifact?.position && {
              text: reviewArtifact?.review_question,
              es_text: reviewArtifact?.es_review_question,
              language_id: [1, 2],
              artifact_type_id: 7,
              artifact_id: reviewArtifact?.id,
            },
          reviewArtifact &&
            (reviewArtifact?.second_review_question ||
              reviewArtifact?.es_second_review_question) &&
            reviewArtifact?.position && {
              text: reviewArtifact?.second_review_question,
              es_text: reviewArtifact?.es_second_review_question,
              language_id: [1, 2],
              artifact_type_id: 15,
              artifact_id: reviewArtifact?.id,
            },
          reviewArtifact &&
            (reviewArtifact?.referral_question ||
              reviewArtifact?.es_referral_question) &&
            reviewArtifact?.position && {
              text: reviewArtifact?.referral_question,
              es_text: reviewArtifact?.es_referral_question,
              language_id: [1, 2],
              artifact_type_id: 8,
              artifact_id: reviewArtifact?.id,
            },
          reviewArtifact &&
            (reviewArtifact?.message || reviewArtifact?.es_message) &&
            reviewArtifact?.position && {
              text: reviewArtifact?.message,
              es_text: reviewArtifact?.es_message,
              language_id: [1, 2],
              artifact_type_id: 9,
              artifact_id: reviewArtifact?.id,
            },

          // ⬇️ CRITICAL CHANGE: Only add service maintenance artifacts if the toggle is ON
          ...(artifacts?.service_maintenance_followup
            ? [
                {
                  msg:
                    serviceArtifact?.followup_message_1 ||
                    SERVICE_MAINTENANCE_DEFAULTS.followup_message_1,
                  es_msg:
                    serviceArtifact?.es_followup_message_1 ||
                    SERVICE_MAINTENANCE_DEFAULTS.es_followup_message_1,
                  followup: 1,
                },
                {
                  msg:
                    serviceArtifact?.followup_message_2 ||
                    SERVICE_MAINTENANCE_DEFAULTS.followup_message_2,
                  es_msg:
                    serviceArtifact?.es_followup_message_2 ||
                    SERVICE_MAINTENANCE_DEFAULTS.es_followup_message_2,
                  followup: 2,
                },
                {
                  msg:
                    serviceArtifact?.followup_message_3 ||
                    SERVICE_MAINTENANCE_DEFAULTS.followup_message_3,
                  es_msg:
                    serviceArtifact?.es_followup_message_3 ||
                    SERVICE_MAINTENANCE_DEFAULTS.es_followup_message_3,
                  followup: 3,
                },
              ]
                .filter(({ msg, es_msg }) => msg || es_msg)
                .map(({ msg, es_msg, followup }) => ({
                  text: msg,
                  es_text: es_msg,
                  language_id: [1, 2],
                  artifact_type_id: 16,
                  artifact_id: serviceArtifact?.id,
                  followup_number: followup,
                }))
            : []),

          tradeArtifact &&
            (tradeArtifact?.text || tradeArtifact?.es_text) && {
              text: tradeArtifact?.text,
              es_text: tradeArtifact?.es_text,
              language_id: [1, 2],
              artifact_type_id: 10,
              artifact_id: tradeArtifact?.id,
            },

          quoteArtifact &&
            (quoteArtifact?.text || quoteArtifact?.es_text) && {
              text: quoteArtifact?.text,
              es_text: quoteArtifact?.es_text,
              language_id: [1, 2],
              artifact_type_id: 11,
              artifact_id: quoteArtifact?.id,
            },
          quoteArtifact &&
            (quoteArtifact?.quote_question ||
              quoteArtifact?.es_quote_question) && {
              text: quoteArtifact?.quote_question,
              es_text: quoteArtifact?.es_quote_question,
              language_id: [1, 2],
              artifact_type_id: 12,
              artifact_id: quoteArtifact?.id,
            },
          englishText &&
            englishText?.text && {
              text: englishText?.text,
              id: englishText?.id,
              language_id: [1],
              isOther: true,
            },
          spanishText &&
            spanishText?.text && {
              es_text: spanishText?.text,
              id: spanishText?.id,
              language_id: [2],
              isOther: true,
            },
        ].filter(Boolean);
        console.log("check", arr);
        if (arr.length && selectedAvatar) {
          setTiming({
            arr_length: arr?.length,
            time: arr?.length * 15,
          });
          await videoGenerate({
            variables: {
              videoInput: {
                dealership_id: parseInt(dealershipId),
                inputs: arr,
              },
            },
          });
        }
      }
    },
  });

  const [updateSalesAids] = useMutation(UPDATE_SALES_AIDS);

  useEffect(() => {
    if (
      !artifacts?.review?.review_question ||
      !artifacts?.review?.second_review_question
    ) {
      setArtifacts((prev) => ({
        ...prev,
        verification_followup: false,
        csi_followup: false,
      }));
    }
  }, [artifacts?.review]);

  useEffect(() => {
    if (isSave) {
      console.log("sending VTT", artifacts?.vehicle_transaction_type);
      const reviewUrlArray = artifacts.review || {};
      const serviceUrlArray = artifacts.service_maintenance || {};
      const dealerUrlArray = artifacts.dealer_app || {};
      const appointmentArtifact = artifacts.appointment || {};
      const WalkthroughVideo = artifacts.walkthrough_video || {};

      manageArtifacts({
        variables: {
          artifactsInput: {
            dealership_id: parseInt(dealershipId),
            follow_up_days: parseInt(artifacts?.follow_up_days),
            csi_followup_days: parseInt(artifacts?.csi_followup_days),
            service_maintenance_followup_1: parseInt(
              artifacts?.service_maintenance_followup_1,
            ),
            service_maintenance_followup_2: parseInt(
              artifacts?.service_maintenance_followup_2,
            ),
            service_maintenance_followup_3: parseInt(
              artifacts?.service_maintenance_followup_3,
            ),
            verification_followup: artifacts?.verification_followup,
            csi_followup: artifacts?.csi_followup,
            service_maintenance_followup:
              artifacts?.service_maintenance_followup,
            updated_by: auth?.user?.user_id,
            avatar_id: selectedAvatar || "",
            text_artifact:
              artifacts?.text.length > 0
                ? artifacts?.text
                    .filter((data) => data?.text || data?.es_text)
                    .map((text) => ({
                      id: text?.id,
                      artifactId: text?.artifactId,
                      text: text?.text,
                      es_text: text?.es_text,
                      position: text?.position,
                    }))
                : [],
            survey_artifact:
              artifacts?.survey.length > 0
                ? artifacts?.survey
                    .filter(
                      (data) =>
                        (data?.question || data?.es_question) &&
                        ((data?.options && data?.options.length > 0) ||
                          (data?.es_options && data?.es_options.length > 0)),
                    )
                    .map((survey) => ({
                      id: survey?.id,
                      artifactId: survey?.artifactId,
                      question: survey?.question,
                      es_question: survey?.es_question,
                      position: survey?.position,
                      options: survey?.options,
                      es_options: survey?.es_options,
                    }))
                : [],
            video_artifact:
              artifacts?.video.length > 0
                ? artifacts?.video
                    .filter(
                      (data) =>
                        (data?.title || data?.es_title) &&
                        (data?.url || data?.es_url),
                    )
                    .map((video) => ({
                      id: video?.id,
                      artifactId: video?.artifactId,
                      title: video?.title,
                      es_title: video?.es_title,
                      position: video?.position,
                      url: video?.url,
                      es_url: video?.es_url,
                    }))
                : [],
            review_artifact: {
              id: parseInt(reviewUrlArray?.id) || null,
              artifactId: reviewUrlArray?.artifactId,
              message: reviewUrlArray?.message || "",
              es_message: reviewUrlArray?.es_message || "",
              facebook: reviewUrlArray?.facebook || "",
              google: reviewUrlArray?.google || "",
              dealer_rater: reviewUrlArray?.dealer_rater || "",
              position: reviewUrlArray?.position || null,
              review_question: reviewUrlArray?.review_question || null,
              second_review_question:
                reviewUrlArray?.second_review_question || null,
              es_second_review_question:
                reviewUrlArray?.es_second_review_question || null,
              es_review_question: reviewUrlArray?.es_review_question || null,
              referral_question: reviewUrlArray?.referral_question || null,
              es_referral_question:
                reviewUrlArray?.es_referral_question || null,
            },

            service_maintenance_artifact: {
              id: parseInt(serviceUrlArray?.id) || null,
              followup_message_1:
                serviceUrlArray?.followup_message_1 ||
                SERVICE_MAINTENANCE_DEFAULTS.followup_message_1,
              es_followup_message_1:
                serviceUrlArray?.es_followup_message_1 ||
                SERVICE_MAINTENANCE_DEFAULTS.es_followup_message_1,
              followup_message_2:
                serviceUrlArray?.followup_message_2 ||
                SERVICE_MAINTENANCE_DEFAULTS.followup_message_2,
              es_followup_message_2:
                serviceUrlArray?.es_followup_message_2 ||
                SERVICE_MAINTENANCE_DEFAULTS.es_followup_message_2,
              followup_message_3:
                serviceUrlArray?.followup_message_3 ||
                SERVICE_MAINTENANCE_DEFAULTS.followup_message_3,
              es_followup_message_3:
                serviceUrlArray?.es_followup_message_3 ||
                SERVICE_MAINTENANCE_DEFAULTS.es_followup_message_3,
            },

            dealer_app_artifact: {
              id: parseInt(dealerUrlArray?.id) || null,
              artifactId: dealerUrlArray?.artifactId,
              message: dealerUrlArray?.message || "",
              es_message: dealerUrlArray?.es_message || "",
              playstore: dealerUrlArray?.playstore || "",
              appstore: dealerUrlArray?.appstore || "",
              position: dealerUrlArray?.position || null,
            },
            appointment_artifact: {
              id: parseInt(appointmentArtifact?.id) || null,
              artifactId: appointmentArtifact?.artifactId,
              message: appointmentArtifact?.message || "",
              es_message: appointmentArtifact?.es_message || "",
              preference_options: appointmentArtifact?.preference_options || [],
              es_preference_options:
                appointmentArtifact?.es_preference_options || [],
              position: appointmentArtifact?.position || null,
            },
            walkthrough: {
              id: parseInt(WalkthroughVideo?.id) || null,
              video_url: WalkthroughVideo?.video_url,
              es_video_url: WalkthroughVideo?.es_video_url,
              text: WalkthroughVideo?.text,
              es_text: WalkthroughVideo?.es_text,
              knowledgehub_video_url: WalkthroughVideo?.knowledgehub_video_url,
              es_knowledgehub_video_url:
                WalkthroughVideo?.es_knowledgehub_video_url,
              knowledgehub_text: WalkthroughVideo?.knowledgehub_text,
              es_knowledgehub_text: WalkthroughVideo?.es_knowledgehub_text,
            },
            services:
              artifacts?.services?.length > 0
                ? artifacts?.services.map((service) => ({
                    id: service?.id,
                    service_text:
                      service?.service_text ||
                      (service?.service_id === 1
                        ? ServiceData[0]?.english_text
                        : service?.service_id === 2
                          ? ServiceData[1]?.english_text
                          : service?.service_id === 3
                            ? ServiceData[2]?.english_text
                            : service?.service_id === 4
                              ? ServiceData[3]?.english_text
                              : ""),
                    es_service_text:
                      service?.es_service_text ||
                      (service?.service_id === 1
                        ? ServiceData[0]?.spanish_text
                        : service?.service_id === 2
                          ? ServiceData[1]?.spanish_text
                          : service?.service_id === 3
                            ? ServiceData[2]?.spanish_text
                            : service?.service_id === 4
                              ? ServiceData[3]?.spanish_text
                              : ""),
                    service_id: service?.service_id,
                  }))
                : [],
            tradeArtifactInput: {
              id: parseInt(artifacts?.trade_artifact?.id) || null,
              text: artifacts?.trade_artifact?.text || TRADE_DATA.english_text,
              es_text:
                artifacts?.trade_artifact?.es_text || TRADE_DATA.spanish_text,
            },
            quoteArtifactInput: {
              id: parseInt(artifacts?.request_quote_artifact?.id) || null,
              text:
                artifacts?.request_quote_artifact?.text ||
                QUOTE_DATA.english_text,
              es_text:
                artifacts?.request_quote_artifact?.es_text ||
                QUOTE_DATA.spanish_text,
              quote_options:
                artifacts?.request_quote_artifact?.quote_options.length > 0
                  ? artifacts?.request_quote_artifact?.quote_options
                  : QUOTE_DATA.quote_options,
              es_quote_options:
                artifacts?.request_quote_artifact?.es_quote_options.length > 0
                  ? artifacts?.request_quote_artifact?.es_quote_options
                  : QUOTE_DATA.es_quote_options,
              quote_question:
                artifacts?.request_quote_artifact?.quote_question ||
                QUOTE_DATA.question_text,
              es_quote_question:
                artifacts?.request_quote_artifact?.es_quote_question ||
                QUOTE_DATA.es_question_text,
            },
            warrantyArtifactInput: {
              id: parseInt(artifacts?.warranty?.id) || null,
              // warranty_message: artifacts?.warranty?.warranty_message || "",
              // warranty_es_message: artifacts?.warranty?.warranty_es_message || "",
              is_enabled: artifacts?.warranty?.is_enabled || false,
              position: artifacts?.warranty?.position || null,
            },
            vehicleTransactionInput: artifacts?.vehicle_transaction_type?.map(
              (vtt) => ({
                id: vtt?.id,
                artifactId: vtt?.artifactId,
                vehicle_information: vtt?.vehicle_information,
                es_vehicle_information: vtt?.es_vehicle_information,
                vehicle_message: vtt?.vehicle_message,
                es_vehicle_message: vtt?.es_vehicle_message,
                // ── FIX: stringify only if still an object (prevents double-stringify) ──
                vehicle_options:
                  typeof vtt?.vehicle_options === "string"
                    ? vtt.vehicle_options
                    : JSON.stringify(vtt?.vehicle_options),
                es_vehicle_options:
                  typeof vtt?.es_vehicle_options === "string"
                    ? vtt.es_vehicle_options
                    : JSON.stringify(vtt?.es_vehicle_options),
                transaction_message: vtt?.transaction_message,
                es_transaction_message: vtt?.es_transaction_message,
                transaction_options:
                  typeof vtt?.transaction_options === "string"
                    ? vtt.transaction_options
                    : JSON.stringify(vtt?.transaction_options),
                es_transaction_options:
                  typeof vtt?.es_transaction_options === "string"
                    ? vtt.es_transaction_options
                    : JSON.stringify(vtt?.es_transaction_options),
                position: vtt?.position,
              }),
            ),
            displayRules: order
              .map((item) => {
                // ── FIX: look up bubbles by artifactId (which now correctly
                //         matches the keying set in fetchArtifacts) ──
                const bubbleKey = item.artifactId || item.id;
                const bubbles = bubbleStates[bubbleKey] || {};

                const artifact_type_id =
                  item.text || item.es_text
                    ? 1
                    : item.question || item.es_question
                      ? 2
                      : item.url || item.es_url
                        ? 3
                        : item.appstore || item.playstore
                          ? 5
                          : item.preference_options || item.es_preference_options
                            ? 6
                            : item.review_question || item.es_review_question
                              ? 7
                              : item.vehicle_information ||
                                  item.es_vehicle_information
                                ? 17
                                : item.is_enabled
                                  ? 18
                                  : 0;

                if (artifact_type_id === 0) return null;

                return {
                  artifact_type_id,
                  artifact_id: item.id || 0,
                  artifactId: item.artifactId,
                  vehicle_rules: JSON.stringify({
                    N: bubbles.N ?? true,
                    U: bubbles.U ?? true,
                    CPO: bubbles.CPO ?? true,
                    O: bubbles.O ?? true,
                  }),
                  transaction_rules: JSON.stringify({
                    L: bubbles.L ?? true,
                    F: bubbles.F ?? true,
                    C: bubbles.C ?? true,
                    B: bubbles.B ?? true,
                  }),
                };
              })
              .filter(Boolean),
          },
        },
      }).then((data) => {
        if (data?.data?.manageArtifacts?.dealership_id) {
          setSuccess(true);
          setTimeout(() => {
            setSuccess(false);
            if (edit && !selectedAvatar) refetch();
          }, 2000);
        }
      });
      setSave(false);
    }
  }, [artifacts]);

  const handleSave = async () => {
    const updatePosition = order.map((data, index) => ({
      ...data,
      position: index + 1,
    }));

    setOrder(updatePosition);

    setArtifacts((prev) => {
      const updatedArtifacts = { ...prev };

      const updateArtifactPositions = (artifactArray) =>
        artifactArray.map((artifact) => {
          const foundArtifact = updatePosition.find(
            (x) => x.artifactId === artifact?.artifactId,
          );
          return foundArtifact || { ...artifact, position: null };
        });

      ["text", "survey", "vehicle_transaction_type", "video"].forEach((key) => {
        updatedArtifacts[key] = updateArtifactPositions(prev[key]);
      });

      ["appointment", "dealer_app", "review", "warranty"].forEach((key) => {
        const foundArtifact = updatePosition.find(
          (x) => x.artifactId === prev[key]?.artifactId,
        );
        updatedArtifacts[key] = foundArtifact
          ? foundArtifact
          : prev[key]?.artifactId
            ? { ...prev[key], position: null }
            : prev[key];
      });

      return updatedArtifacts;
    });

    setSave(true);
  };

  console.log("order", artifacts);
  return (
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        gap: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: "65%",
          height: "100%",
          p: "16px 0px 0px 16px",
        }}
      >
        <Box sx={SalesAidsStyles.artifactSentence}>
          <Typography variant={data ? "h6" : "body1"}>
            Sales Aids/Artifacts
          </Typography>
          <Switch checked={checked} size="small" onChange={switchHandle} />
        </Box>
        {checked ? (
          <Box sx={SalesAidsStyles.accordiansBox}>
            <AccordianUtils
              index={0}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Text"}
              icon={<Abc sx={SalesAidsStyles.abcIcon} />}
              content={
                <TextArtifacts
                  artifacts={artifacts?.text}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                  handleRemove={handleRemove}
                  edit={edit}
                />
              }
            />
            <AccordianUtils
              index={1}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Survey"}
              icon={<HelpOutlineIcon sx={SalesAidsStyles.abcIcon} />}
              content={
                <SurveyArtifact
                  artifacts={artifacts?.survey}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                  handleRemove={handleRemove}
                  edit={edit}
                />
              }
            />
            <AccordianUtils
              index={2}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Video"}
              icon={
                <SlowMotionVideoOutlinedIcon sx={SalesAidsStyles.abcIcon} />
              }
              content={
                <VideoArtifact
                  artifacts={artifacts?.video}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                  handleRemove={handleRemove}
                  edit={edit}
                />
              }
            />
            <AccordianUtils
              index={3}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Reviews and Referral"}
              icon={<RateReviewOutlined sx={SalesAidsStyles.abcIcon} />}
              content={
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 1,
                    bgcolor: artifacts?.review?.isEdit ? "#FFF7F7" : null,
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "20px",
                      flexDirection: "row",
                      justifyContent: "start",
                      alignItems: "center",
                      pt: 3,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        gap: "10px",
                        flexDirection: "row",
                        justifyContent: "start",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <Switch
                        checked={artifacts?.verification_followup}
                        size="small"
                        onChange={(e, newValue) => {
                          setArtifacts({
                            ...artifacts,
                            verification_followup: newValue,
                          });
                        }}
                        disabled={
                          !artifacts?.review?.review_question ||
                          !artifacts?.review?.second_review_question
                        }
                      />
                      <Typography sx={{ width: "80px", fontSize: "15px" }}>
                        Referral Followup
                      </Typography>
                      <FormControl variant="outlined" sx={{ minWidth: 300 }}>
                        <Autocomplete
                          disabled={!artifacts?.verification_followup}
                          options={referralFollowup}
                          getOptionLabel={(option) => option}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          value={artifacts?.follow_up_days}
                          onChange={(e, newValue) => {
                            setArtifacts({
                              ...artifacts,
                              follow_up_days: newValue,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Follow Up" />
                          )}
                        />
                      </FormControl>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        gap: "10px",
                        flexDirection: "row",
                        justifyContent: "start",
                        alignItems: "center",
                        flex: 1,
                      }}
                    >
                      <Switch
                        checked={artifacts?.csi_followup}
                        size="small"
                        onChange={(e, newValue) => {
                          setArtifacts({
                            ...artifacts,
                            csi_followup: newValue,
                          });
                        }}
                      />
                      <Typography sx={{ width: "80px", fontSize: "15px" }}>
                        CSI Follow up
                      </Typography>
                      <FormControl variant="outlined" sx={{ minWidth: 300 }}>
                        <Autocomplete
                          disabled={!artifacts?.csi_followup}
                          options={csiFollowup}
                          getOptionLabel={(option) => option}
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          value={artifacts?.csi_followup_days}
                          onChange={(e, newValue) => {
                            setArtifacts({
                              ...artifacts,
                              csi_followup_days: newValue,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField {...params} label="Follow Up" />
                          )}
                        />
                      </FormControl>
                    </Box>
                  </Box>
                  <ReviewComponent
                    artifacts={artifacts?.review}
                    setArtifacts={setArtifacts}
                    setError={setError}
                    handleArrowClick={handleArrowClick}
                  />
                </Box>
              }
            />
            <AccordianUtils
              index={4}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Dealer Engagement App"}
              icon={<CategoryOutlined sx={SalesAidsStyles.abcIcon} />}
              content={
                <DealerEngagement
                  artifacts={artifacts?.dealer_app}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                />
              }
            />
            <AccordianUtils
              index={5}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Appointment"}
              icon={<CategoryOutlined sx={SalesAidsStyles.abcIcon} />}
              content={
                <Appointment
                  artifacts={artifacts?.appointment}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                />
              }
            />
            <AccordianUtils
              index={6}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Walkthrough Video"}
              icon={<CategoryOutlined sx={SalesAidsStyles.abcIcon} />}
              content={
                <WalkthroughVideo
                  artifacts={artifacts?.walkthrough_video}
                  setArtifacts={setArtifacts}
                  setError={setError}
                />
              }
            />
            <AccordianUtils
              index={7}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Services"}
              icon={<CategoryOutlined sx={SalesAidsStyles.abcIcon} />}
              content={
                <AdminServices
                  artifacts={artifacts?.services}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                />
              }
            />
            <AccordianUtils
              index={8}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Trade Vehicle"}
              icon={<CategoryOutlined sx={SalesAidsStyles.abcIcon} />}
              content={
                <TradeVehicleArtifacts
                  artifacts={artifacts?.trade_artifact}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                  handleRemove={handleRemove}
                  edit={edit}
                />
              }
            />
            <AccordianUtils
              index={9}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Request Quote"}
              icon={<CategoryOutlined sx={SalesAidsStyles.abcIcon} />}
              content={
                <RequestQuoteArtifact
                  artifacts={artifacts?.request_quote_artifact}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                  handleRemove={handleRemove}
                  edit={edit}
                />
              }
            />
            <AccordianUtils
              index={10}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Vehicle and Transaction Type"}
              icon={<CategoryOutlined sx={SalesAidsStyles.abcIcon} />}
              content={
                <VehicleTransactionType
                  artifacts={artifacts?.vehicle_transaction_type}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                  handleRemove={handleRemove}
                  edit={edit}
                />
              }
            />
            <AccordianUtils
              index={11}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Service/Maintenance Follow Up"}
              icon={<CategoryOutlined sx={SalesAidsStyles.abcIcon} />}
              content={
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "row",
                      justifyContent: "start",
                      alignItems: "center",
                      pt: 2,
                    }}
                  >
                    <Switch
                      checked={artifacts?.service_maintenance_followup}
                      size="small"
                      onChange={(e, newValue) => {
                        setArtifacts({
                          ...artifacts,
                          service_maintenance_followup: newValue,
                        });
                      }}
                    />
                    <Typography sx={{ width: "150px", fontSize: "15px" }}>
                      Service/Maintenance Follow Up
                    </Typography>
                    <FormControl variant="outlined" sx={{ minWidth: 225 }}>
                      <Autocomplete
                        disabled={!artifacts?.service_maintenance_followup}
                        options={serviceMaintenanceFollowup}
                        getOptionLabel={(option) => option}
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        value={artifacts?.service_maintenance_followup_1}
                        onChange={(e, newValue) => {
                          setArtifacts({
                            ...artifacts,
                            service_maintenance_followup_1: newValue,
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Follow Up" />
                        )}
                      />
                    </FormControl>
                    <FormControl variant="outlined" sx={{ minWidth: 225 }}>
                      <Autocomplete
                        disabled={!artifacts?.service_maintenance_followup}
                        options={serviceMaintenanceFollowup}
                        getOptionLabel={(option) => option}
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        value={artifacts?.service_maintenance_followup_2}
                        onChange={(e, newValue) => {
                          setArtifacts({
                            ...artifacts,
                            service_maintenance_followup_2: newValue,
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Follow Up" />
                        )}
                      />
                    </FormControl>
                    <FormControl variant="outlined" sx={{ minWidth: 225 }}>
                      <Autocomplete
                        disabled={!artifacts?.service_maintenance_followup}
                        options={serviceMaintenanceFollowup}
                        getOptionLabel={(option) => option}
                        isOptionEqualToValue={(option, value) =>
                          option === value
                        }
                        value={artifacts?.service_maintenance_followup_3}
                        onChange={(e, newValue) => {
                          setArtifacts({
                            ...artifacts,
                            service_maintenance_followup_3: newValue,
                          });
                        }}
                        renderInput={(params) => (
                          <TextField {...params} label="Follow Up" />
                        )}
                      />
                    </FormControl>
                  </Box>
                  <ServiceMaintenance
                    artifacts={artifacts?.service_maintenance}
                    setArtifacts={setArtifacts}
                    setError={setError}
                    handleArrowClick={handleArrowClick}
                    isFollowupEnabled={artifacts?.service_maintenance_followup}
                  />
                </Box>
              }
            />
            <AccordianUtils
              index={12}
              expandedIndex={expandedIndex}
              setExpandedIndex={setExpandedIndex}
              Text={"Warranty"}
              icon={<Abc sx={SalesAidsStyles.abcIcon} />}
              content={
                <WarrantyArtifacts
                  artifacts={artifacts?.warranty}
                  setArtifacts={setArtifacts}
                  setError={setError}
                  handleArrowClick={handleArrowClick}
                  order={order}
                  setOrder={setOrder}
                />
              }
            />
          </Box>
        ) : (
          <Box gap="6px" sx={SalesAidsStyles.enablemessage}>
            <WarningAmberOutlined sx={DialogStyle.error} />
            <Typography variant="caption" color="#C18803">
              {!checked
                ? "Please enable sales aids to modify artifacts details."
                : "Please enable Knowledge Hub to modify artifacts details."}
            </Typography>
          </Box>
        )}
      </Box>

      {checked && (
        <>
          <Divider orientation="vertical" variant="middle" flexItem />
          <Box sx={SalesAidsStyles.executionOutsideBox}>
            <OrderComponent
              order={order}
              setArtifacts={setArtifacts}
              artifacts={artifacts}
              updateArtifacts={updateArtifacts}
              edit={edit}
              setOrder={setOrder}
              bubbleStates={bubbleStates}
              setBubbleStates={setBubbleStates}
            />
            {success ? (
              <Box sx={SalesAidsStyles.sucessBox}>
                <CheckCircle color={"primary"} />
                <span
                  style={{
                    color: Theme.palette.primary.main,
                    marginLeft: "4px",
                  }}
                >
                  SUCCESS
                </span>
              </Box>
            ) : (
              <Box sx={SalesAidsStyles.executionButton}>
                {isAISuccess && (
                  <Box sx={{ ...DialogStyle.errorIcon, mb: 1 }} gap="6px">
                    <ErrorOutlineOutlined sx={DialogStyle.error} />
                    <Typography variant="caption" color="#C18803">
                      {aiTiming.arr_length} Artifacts are updated. AI videos are
                      updated in {aiTiming.time} minutes.
                    </Typography>
                  </Box>
                )}
                <AppButton
                  variant={"contained"}
                  buttonText={edit ? "Update Artifact" : "create Artifact"}
                  clickHandler={handleSave}
                  loading={loading}
                  disabled={!checked || isError}
                  sx={{ width: "100%" }}
                />
              </Box>
            )}
          </Box>
        </>
      )}
    </Box>
  );
};

export default ArtifactsParent;